import React from 'react'
import '../styles/About.css'
import { useTranslation } from '../context/LanguageContext.jsx'

const About = () => {
  const { t, dict } = useTranslation()

  const teamMembers = [
    {
      name: 'Christos Mantzos',
      roleKey: 'lead',
      linkedin: 'https://www.linkedin.com/in/xristos-mantsos/',
      github: 'https://github.com/egkelados',
    },
    {
      name: 'Stylianos Kalaitzis',
      roleKey: 'web',
      linkedin: 'https://www.linkedin.com/in/stylianos-kalaitzis-730902260/',
      github: 'https://github.com/stylianos1995',
    },
  ]

  const focus = dict.about.focus ?? []
  const story = dict.about.story ?? []

  return (
    <section id="about" className="about">
      <div className="about-inner">
        <header className="about-header">
          <h2>{t('about.title')}</h2>
          <p className="about-subtitle">{t('about.subtitle')}</p>
        </header>

        <div className="about-layout">
          <div className="about-copy">
            {story.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}

            {focus.length > 0 && (
              <ul className="about-focus" aria-label={t('about.focusLabel')}>
                {focus.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </div>

          <div className="about-team">
            <h3 className="about-team-heading">{t('about.teamTitle')}</h3>
            <ul className="team-list">
              {teamMembers.map((member) => (
                <li key={member.name} className="team-row">
                  <div className="team-text">
                    <p className="member-name">{member.name}</p>
                    <p className="member-role">{dict.about.roles[member.roleKey]}</p>
                  </div>
                  <div className="team-social-links">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-social-link team-linkedin"
                      aria-label={`${member.name} LinkedIn`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                    <a
                      href={member.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-social-link team-github"
                      aria-label={`${member.name} GitHub`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                      </svg>
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
